module.exports = __webpack_public_path__ + "img/moyen.d2375e1.svg";